import React from 'react';
//mui
import { Grid } from '@mui/material';
//widgets
import { HeaderWidget } from '../header/HeaderWidget';
//icons
import { HomeTranspBulkIcon } from '../../icons-lib';

//i18n
import i18n from 'i18';
import config from '../../config';

const HeaderSection = ({ currentUser, actions }) => {
    const currentUserName = currentUser
        ? `${currentUser.firstName} ${currentUser.lastName}`
        : '';
    const image = config?.bannerImages?.dashboard || '';
    return (
        <Grid item xs={12} sm={12} md={12}>
            <HeaderWidget
                title={i18n.t('dashboard.welcome', { name: currentUserName })}
                subtitle={i18n.t('dashboard.welcomeSubtitle')}
                image={image}
                startIcon={HomeTranspBulkIcon}
                actions={actions}
            />
        </Grid>
    );
};

export default HeaderSection;
